/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Context from "../../../../store/context";
import labels from "../helpers/labels";
import actionOptionsConfig from "./actionOptionsConfig";
import LogicItemOptions from "../Options/LogicItemOptions";

export default function ActionOptions({
  dispatch,
  action,
  rule,
  event,
  eventListener,
}) {
  const navigate = useNavigate();
  const params = useParams();
  const pageProps = JSON.parse(
    document.querySelector("#app").dataset.page
  ).props;
  const context = useContext(Context);
  const optionsPath = `/library/logic/builder/${params.projectID}/workflow/${params.workflowUUID}/event/${params.event}/listener/${params.listenerUUID}/action/${action.UUID}`;
  const parentPath = `/library/logic/builder/${params.projectID}/workflow/${params.workflowUUID}/event/${params.event}/listener/${params.listenerUUID}`;
  const config = actionOptionsConfig({
    action,
    context,
    eventListener,
    pageProps,
    params,
    rule,
    event,
    dispatch,
    navigate,
  })[action.Type];

  return (
    <LogicItemOptions
      item={action}
      itemType="action"
      title={`Action options - ${labels[action.Type]}`}
      config={config}
      isOpen={params.actionUUID === action.UUID}
      optionsPath={optionsPath}
      parentPath={parentPath}
      errorFilter={(error) => error.action?.UUID === action.UUID}
      setItem={(newAction) =>
        dispatch({
          type: "edit-action",
          actionId: action.UUID,
          newAction,
        })
      }
    />
  );
}
